import React, { useEffect, useState } from 'react';
import { Control, useFormContext } from 'react-hook-form';
import { Box, Button, Grid, Stack, } from '@mui/material';
import { RegulationFormValues, ResponsibilityType, User } from '../../DataTable/dataTypes';
import DropdownListField from './DropdownListField';

interface ResponsibilityFieldsProps {
  control: Control<RegulationFormValues>;
  taskIndex: number;
  users: User[];
  types: ResponsibilityType[];
  disabled?: boolean;
  userResponsabilityLst: any
}

const ResponsibilityFields: React.FC<ResponsibilityFieldsProps> = ({
  control,
  taskIndex,
  users,
  types,
  disabled,
  userResponsabilityLst
}) => {

  const { setValue } = useFormContext<RegulationFormValues>();
  const [ejecutor2, showEjecutor2] = useState(false);
  const [ejecutor3, showEjecutor3] = useState(false);
  const [ejecutor4, showEjecutor4] = useState(false);
  const [revisor2, showRevisor2] = useState(false);

  // console.log({ types })
  // console.log({ taskIndex })
  // console.log({ userResponsabilityLst })

  const findResponsibility = (responsibilityType: string, description: string) =>
    types.find(
      (type) =>
        type.type === responsibilityType || type.description === description
    );

  const mainResponsibility = findResponsibility('main', 'Principal');
  const executionResponsibility = findResponsibility('ejecutor', 'Ejecución');
  const revisionResponsibility = findResponsibility('revisor', 'Revisión');
  const validationResponsibility = findResponsibility('validador', 'Validación');

  useEffect(() => {
    if (userResponsabilityLst.length >= 5) showEjecutor2(true)
    if (userResponsabilityLst.length >= 6) showEjecutor3(true)
    if (userResponsabilityLst.length >= 7) showEjecutor4(true)
    if (userResponsabilityLst.length >= 8) showRevisor2(true)
  }, [userResponsabilityLst])

  useEffect(() => {
    if (revisor2 && revisionResponsibility) {
      setValue(
        `tasks.${taskIndex}.taskUserResponsibilities.7.responsibility`,
        revisionResponsibility,
        { shouldDirty: true, shouldValidate: true }
      );
    }
  }, [revisor2, revisionResponsibility, setValue, taskIndex])

  return (
    <Box
      display="flex"
      flexDirection="row"
      gap="10px"
      mb="20px"
      minWidth="300px"
    >
      <Grid container spacing={1}>

        <Grid item width={250}>

          <DropdownListField
            control={control}
            taskIndex={taskIndex}
            users={users}
            responsibilityIndex={0}
            responsability={"Principal"}
            responsibility={mainResponsibility}
            disabled={disabled}
          />
        </Grid>

        <Grid item width={295}>

          <Stack direction="row" spacing={1} alignItems={'end'}>
            <Grid item width={250}>
              <DropdownListField
                control={control}
                taskIndex={taskIndex}
                users={users}
                responsibilityIndex={1}
                responsability={"Ejecución"}
                responsibility={executionResponsibility}
                disabled={disabled}
              />
            </Grid>
            {!ejecutor2 &&
              <Button sx={{ height: 20, minWidth: 24, width: 24, padding: 0 }} variant="contained" onClick={() => showEjecutor2(true)}>+</Button>
            }
          </Stack>

          {ejecutor2 &&
            <Stack direction="row" spacing={1} alignItems={'end'}>
              <Grid item width={250}>
                <DropdownListField
                  control={control}
                  taskIndex={taskIndex}
                  users={users}
                  responsibilityIndex={4}
                  responsability={"Ejecución"}
                  responsibility={executionResponsibility}
                  disabled={disabled}
                  showLbl={false}
                />
              </Grid>
              <Stack direction="column" spacing={2}>
                <Button sx={{ height: 20, minWidth: 24, width: 24, padding: 0 }} variant="contained" color="error"
                  onClick={() => {
                    showEjecutor2(false)
                    delete userResponsabilityLst[4]
                  }}>-</Button>
                {!ejecutor3 &&
                  <Button sx={{ height: 20, minWidth: 24, width: 24, padding: 0 }} variant="contained" onClick={() => showEjecutor3(true)}>+</Button>
                }
              </Stack>
            </Stack>
          }

          {ejecutor3 &&
            <Stack direction="row" spacing={1} alignItems={'end'}>
              <Grid item width={250}>
                <DropdownListField
                  control={control}
                  taskIndex={taskIndex}
                  users={users}
                  responsibilityIndex={5}
                  responsability={"Ejecución"}
                  responsibility={executionResponsibility}
                  disabled={disabled}
                  showLbl={false}
                />
              </Grid>
              <Stack direction="column" spacing={2}>
                <Button sx={{ height: 20, minWidth: 24, width: 24, padding: 0 }} variant="contained" color="error"
                  onClick={() => {
                    showEjecutor3(false)
                    delete userResponsabilityLst[5]
                  }}>-</Button>
                {!ejecutor4 &&
                  <Button sx={{ height: 20, minWidth: 24, width: 24, padding: 0 }} variant="contained" onClick={() => showEjecutor4(true)}>+</Button>
                }
              </Stack>
            </Stack>
          }

          {ejecutor4 &&
            <Stack direction="row" spacing={1} alignItems={'end'}>
              <Grid item width={250}>
                <DropdownListField
                  control={control}
                  taskIndex={taskIndex}
                  users={users}
                  responsibilityIndex={6}
                  responsability={"Ejecución"}
                  responsibility={executionResponsibility}
                  disabled={disabled}
                  showLbl={false}
                />
              </Grid>
              <Button sx={{ height: 20, minWidth: 24, width: 24, padding: 0 }} variant="contained" color="error"
                onClick={() => {
                  showEjecutor4(false)
                  delete userResponsabilityLst[6]
                }}>-</Button>
            </Stack>
          }
        </Grid>


        <Grid item width={295}>

          <Stack direction="row" spacing={1} alignItems={'end'}>
            <Grid item width={250}>
              <DropdownListField
                control={control}
                taskIndex={taskIndex}
                users={users}
                responsibilityIndex={2}
                responsability={"Revisión"}
                responsibility={revisionResponsibility}
                disabled={disabled}
              />
            </Grid>
            {!revisor2 &&
              <Button sx={{ height: 20, minWidth: 24, width: 24, padding: 0 }} variant="contained" onClick={() => showRevisor2(true)}>+</Button>
            }
          </Stack>

          {revisor2 &&
            <Stack direction="row" spacing={1} alignItems={'end'}>
              <Grid item width={250}>
                <DropdownListField
                  control={control}
                  taskIndex={taskIndex}
                  users={users}
                  responsibilityIndex={7}
                  responsability={"Revisión"}
                  responsibility={revisionResponsibility}
                  disabled={disabled}
                  showLbl={false}
                />
              </Grid>
              <Button sx={{ height: 20, minWidth: 24, width: 24, padding: 0 }} variant="contained" color="error"
                onClick={() => {
                  showRevisor2(false)
                  delete userResponsabilityLst[7]
                }}>-</Button>
            </Stack>
          }
        </Grid>

        <Grid item width={250}>
          <DropdownListField
            control={control}
            taskIndex={taskIndex}
            users={users}
            responsibilityIndex={3}
            responsability={"Validación"}
            responsibility={validationResponsibility}
            disabled={disabled}
          />
        </Grid>
      </Grid>



      {/* {types.map((type, responsibilityIndex) => {
        {console.log({type, responsibilityIndex})}
        return <Box key={responsibilityIndex}>
          <Box mt={2} mb={2}>
            <Typography variant="body2" color="textPrimary">
              {type.description}
            </Typography>
          </Box>          
          <FormControl variant="outlined" fullWidth>
            <InputLabel id={`user-label-${taskIndex}-${responsibilityIndex}`}>
              Responsable
            </InputLabel>
            <Controller
              name={`tasks.${taskIndex}.taskUserResponsibilities.${responsibilityIndex}.user`}
              control={control}
              render={({ field, fieldState }) => (
                <Select
                  {...field}
                  labelId={`user-label-${taskIndex}-${responsibilityIndex}`}
                  label="Responsable"
                  value={field.value?.id || ''}
                  onChange={(event) => {
                    const selectedUser = users.find(
                      (user) => user.id === event.target.value
                    );
                    field.onChange(selectedUser);
                  }}
                  disabled={disabled}
                  error={!!fieldState.error}
                >
                  {users
                    .sort((a, b) => a.username.localeCompare(b.username))
                    .map((user) => (
                      <MenuItem key={user.id} value={user.id}>
                        {user.username}
                      </MenuItem>
                    ))}
                </Select>
              )}
              rules={{
                required:
                  'Debe seleccionar un usuario para esta responsabilidad',
              }}
            />
          </FormControl>
        </Box>
      })} */}

    </Box>
  );
};

export default ResponsibilityFields;
